import { render, staticRenderFns } from "./DaerahPenghasil.vue?vue&type=template&id=bce083aa&scoped=true"
import script from "./DaerahPenghasil.vue?vue&type=script&lang=js"
export * from "./DaerahPenghasil.vue?vue&type=script&lang=js"
import style0 from "./DaerahPenghasil.vue?vue&type=style&index=0&id=bce083aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce083aa",
  null
  
)

export default component.exports